import PropTypes from 'prop-types';
import styled from 'styled-components';

const MainContainer = styled.div`
  margin: 4rem 0;
  width: 100%;
  
  > h1 {
    margin: 0 12rem;

    @media (max-width: 800px) {
      margin: 0 6rem;
    }

    @media (max-width: 600px) {
      margin: 0 3.5rem;
    }
`;

const ContentFluid = ({children}) => {
  return (
    <MainContainer>
      {children}
    </MainContainer>
  );
};

ContentFluid.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.element)
  ])
};

export default ContentFluid;
